// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4824cb9c","239":"2a351403","455":"9b1ac89d"}[chunkId] + ".chunk.js";
};